import { ToggleButton as MuiToggleButton, styled, ToggleButtonGroup } from "@mui/material"
import PropTypes from "prop-types";
import { memo, useCallback } from "react";

const ToggleButton = styled(MuiToggleButton)(() => ({
  '&.MuiToggleButton-root': {
    color: '#706d67',
    backgroundColor: '#DFE0EB',
    border: 0,
    textTransform: 'none',
    '&.Mui-selected': {
      color: '#fff',
      backgroundColor: '#007bff',
      borderBottomLeftRadius: '10px',
      borderTopRightRadius: '10px',
      borderTopLeftRadius: '10px',
      borderBottomRightRadius: '10px'
    },
  },
}));

const SwitchButton = memo(({
  options = [],
  value,
  onChange,
  exclusive = true,
  size = 'medium',
  color = 'primary',
  disabled = false,
  fullWidth = false,
  orientation = 'horizontal',
  'aria-label': ariaLabel,
}) => {
  // Memoized change handler
  const handleChange = useCallback((event, newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  }, [onChange]);

  return (
    <ToggleButtonGroup
      value={value}
      exclusive={exclusive}
      onChange={handleChange}
      aria-label={ariaLabel}
      size={size}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      orientation={orientation}
      className="ml-2 h-8 md:!h-[40px] w-[6rem] md:!w-[10rem] overflow-hidden bg-[#DFE0EB] rounded-xl"
    >
      {options.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          aria-label={option.label}
          className="text-xs md:text-base h-[40px] flex-1 items-center"
        >
          {option.icon && <span className="mr-2">{option.icon}</span>}
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
});

SwitchButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
    })
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func,
  exclusive: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.oneOf(['standard', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  'aria-label': PropTypes.string,
};

export default SwitchButton;
